/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Dodaj"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Usuń wszystkie"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var plPL = Object.assign(TranslationProviderComponent, {
  translations
});

export { plPL as p };
//# sourceMappingURL=pl-PL-BQBO4wOV.js.map
